import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { formatError } from "@/lib/api";
import { toast } from "sonner";
import { Lock } from "lucide-react";

export default function AdminLogin() {
    const { user, login, loading } = useAuth();
    const nav = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [busy, setBusy] = useState(false);

    if (loading) return null;
    if (user) return <Navigate to="/admin" replace />;

    const submit = async (e) => {
        e.preventDefault();
        setBusy(true);
        try {
            await login(email, password);
            toast.success("Connexion réussie");
            nav("/admin", { replace: true });
        } catch (err) {
            toast.error(formatError(err));
        } finally {
            setBusy(false);
        }
    };

    return (
        <main data-testid="admin-login-page" className="min-h-screen flex items-center justify-center px-6 py-32 bg-ink-950">
            <div className="w-full max-w-md">
                <div className="text-center mb-12">
                    <div className="w-12 h-12 mx-auto mb-6 border border-gilt flex items-center justify-center text-gilt">
                        <Lock size={18} strokeWidth={1.2} />
                    </div>
                    <div className="overline mb-3">Espace artiste</div>
                    <h1 className="serif text-4xl">Connexion</h1>
                </div>

                <form onSubmit={submit} className="space-y-8 border border-white/10 p-8 md:p-10 bg-ink-850/50">
                    <input
                        data-testid="login-email"
                        type="email"
                        placeholder="Email"
                        className="input-line"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        autoComplete="email"
                        required
                    />
                    <input
                        data-testid="login-password"
                        type="password"
                        placeholder="Mot de passe"
                        className="input-line"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        autoComplete="current-password"
                        required
                    />
                    <button data-testid="login-submit" type="submit" className="btn-gilt w-full justify-center" disabled={busy}>
                        {busy ? "Connexion…" : "Se connecter"}
                    </button>
                </form>
            </div>
        </main>
    );
}
